export const VIEWED_VENDOR_TOUR = 'VIEWED_VENDOR_TOUR';